import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const getMemberEmailConfirmState = createSelector(membersState, (members) => members.emailConfirm);
